import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id A152DD64-B013-4AE7-B89F-49FC90B2E471
 * name projector-screen
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/projector-screen.svg
 * tags
 * - Device / Tech 
 * - Home Automation 
 */
export const ProjectorScreenIcon = createSvgIcon(<><path d="M4,2A1,1 0 0,0 3,3V4A1,1 0 0,0 4,5H5V14H11V16.59L6.79,20.79L8.21,22.21L11,19.41V22H13V19.41L15.79,22.21L17.21,20.79L13,16.59V14H19V5H20A1,1 0 0,0 21,4V3A1,1 0 0,0 20,2H4Z" /></>, 'ProjectorScreenIcon');
export default ProjectorScreenIcon